(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buce-atc-benefit"] && !Shopify.designMode) return;
  try {
    (() => {
 'use strict';
 if(customElements.get('buce-atc-note'))return;
 function recommendationCopy(copy){
  if(window.buceGreenRecommendationsBound||!copy)return;
  const main=document.getElementById('MainContent');if(!main)return;
  window.buceGreenRecommendationsBound=true;
  const old='Priorizamos la misma marca y colores similares; luego completamos con otras opciones relevantes.';
  const patch=node=>{if(!(node instanceof Element))return;const targets=node.matches('p,.t4s-section-des')?[node]:[];targets.push(...node.querySelectorAll('p,.t4s-section-des'));targets.forEach(el=>{if(el.textContent.replace(/\s+/g,' ').trim()===old)el.textContent=copy;});};
  patch(main);
  new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(patch))).observe(main,{childList:true,subtree:true});
 }
 customElements.define('buce-atc-note',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;
   const buttons=this.closest('.t4s-product-form__buttons');
   const group=buttons?.querySelector(':scope > .t4s-d-flex');
   if(!group)return;
   this.ready=true;group.after(this);
   recommendationCopy(this.dataset.recommendationsCopy);
   this.listener=event=>{
    const state=event.detail?.state?.dataset;if(!state)return;
    let copy='';
    if(this.dataset.volume==='1'&&window.BuceAH){this.textContent=window.BuceAH.nextCopy();this.hidden=!this.textContent;return;}
    if(state.buceWholesale!=='true'&&state.buceExclusive!=='true'&&state.buceHasCode!=='true'){
     const pairs=Number(state.buceVolumePairs),five=Number(state.bucePairs);
     if(this.dataset.august==='true')copy=state.buceComboApplied==='true'?this.dataset.applied:Number(state.buceComboShoes)>0?this.dataset.unlocked:this.dataset.comboCopy;
     else if(this.dataset.five==='1'&&five===5)copy=this.dataset.free;
     else if(this.dataset.five==='1'&&five===4)copy=this.dataset.nextFive;
     else if(this.dataset.volume==='1'&&this.dataset.combo==='1')copy=pairs===0?this.dataset.start:pairs===1?this.dataset.nextTwo:pairs===2?this.dataset.nextThree:pairs===3?this.dataset.nextFour:'';
     else if(this.dataset.combo==='1')copy=this.dataset.comboCopy;
    }
    this.textContent=copy;this.hidden=!copy;
   };
   document.addEventListener('buce:cart-status',this.listener);
   if(window.BuceCartUI)window.BuceCartUI.replay();
  }
 });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buce-battle-offer"] && !Shopify.designMode) return;
  try {
    (()=>{
 const start=()=>{
  document.querySelectorAll('[data-buce-battle-offer]').forEach(el=>{
   if(el.dataset.ready)return;
   el.dataset.ready='true';
   const end=Date.parse(el.dataset.end);
   if(!Number.isFinite(end)){el.remove();return;}
   el.querySelector('[data-battle-date]').textContent=new Intl.DateTimeFormat('es-CO',{timeZone:'America/Bogota',dateStyle:'long',timeStyle:'short'}).format(end);
   let timer;
   const tick=()=>{
    if(!el.isConnected){clearInterval(timer);return;}
    const left=Math.floor((end-Date.now())/1000);
    if(left<=0){el.remove();clearInterval(timer);return;}
    const d=Math.floor(left/86400),h=Math.floor(left%86400/3600),m=Math.floor(left%3600/60),s=left%60;
    const clock=el.querySelector('[data-battle-clock]');
    if(!clock.dataset.ready){
     clock.replaceChildren(...['days','hours','minutes','seconds'].map(key=>{const cell=document.createElement('span'),number=document.createElement('b'),label=document.createElement('small');number.dataset.battleUnit=key;label.textContent=clock.dataset[key];cell.append(number,label);return cell;}));
     clock.dataset.ready='true';
    }
    [d,h,m,s].forEach((value,index)=>{clock.querySelectorAll('[data-battle-unit]')[index].textContent=String(value).padStart(2,'0');});
   };
   tick();if(el.isConnected)timer=setInterval(tick,1000);
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('shopify:section:load',start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buce-complement-card"] && !Shopify.designMode) return;
  try {
    (() => {
 'use strict';
 if(customElements.get('buce-complement-price'))return;
 customElements.define('buce-complement-price',class extends HTMLElement{
  connectedCallback(){
   if(this.connected)return;this.connected=true;
   try{this.prices=JSON.parse(this.querySelector('[data-buce-price-map]').textContent);}catch{return;}
   this.card=this.closest('[data-buce-complement]');
   this.abort=new AbortController();const options={signal:this.abort.signal};
   this.card.addEventListener('change',event=>{if(event.target.matches('select[name="id"]'))this.update();},options);
   document.addEventListener('buce:cart-status',event=>{
    const state=event.detail?.state;if(!state)return;
    this.state=state.dataset;
    let ids=[];try{ids=JSON.parse(this.state.buceProductIds||'[]');}catch{}
    this.card.hidden=ids.map(String).includes(this.card.dataset.buceProductId);
    this.update();
   },options);
   this.update();
   if(window.BuceCartUI)window.BuceCartUI.replay();
  }
  disconnectedCallback(){this.abort?.abort();this.connected=false;}
  update(){
   const selected=this.card.querySelector('[name="id"]')?.value;
   const variant=this.prices[selected||this.dataset.baseVariant];if(!variant)return;
   const state=this.state;
   const blocked=state?state.buceExclusive==='true'||state.buceFreeApplied==='true'||state.buceWholesale==='true'||state.buceHasCode==='true':this.dataset.initialBlocked==='true';
   const hasShoes=state?Number(state.buceComboShoes)>0:this.dataset.initialCartSource==='true';
   const combo=this.dataset.candidateOk==='true'&&hasShoes&&!blocked&&variant.price>5000000;
   this.querySelector('[data-buce-price-normal]').hidden=combo;
   this.querySelector('[data-buce-price-combo]').hidden=!combo;
   this.querySelector('[data-buce-combo-copy]').textContent=this.dataset.copyReady;
   const teaser=this.querySelector('[data-buce-combo-teaser]');
   teaser.hidden=hasShoes||blocked||this.dataset.candidateOk!=='true'||this.dataset.sourceOk!=='true';
   teaser.textContent=this.dataset.copyTeaser;
   if(selected){
    this.querySelector('[data-buce-variant-price]').textContent=variant.money;
    const normalCompare=this.querySelector('[data-buce-variant-compare]');
    normalCompare.textContent=variant.compareMoney;normalCompare.hidden=variant.compare<=variant.price;
   }
   const compare=this.querySelector('[data-buce-combo-compare]'),percent=this.querySelector('[data-buce-combo-percent]'),reference=this.querySelector('[data-buce-combo-reference]');
   compare.textContent=variant.compareMoney;compare.hidden=variant.compare<=5000000;
   percent.hidden=variant.compare<=5000000;
   const saving=variant.compare>5000000?Math.floor((variant.compare-5000000)*100/variant.compare):0;
   if(!percent.hidden)percent.textContent='-'+saving+'%';
   reference.hidden=true;
  }
 });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buce-discount-badge"] && !Shopify.designMode) return;
  try {
    (() => {
 'use strict';
 const bind = () => document.querySelectorAll('.t4s-single-product-badge>.t4s-badge-sale').forEach(badge => {
  if(badge.dataset.buceGreenBound==='true')return;
  badge.dataset.buceGreenBound='true';
  const paint=()=>{const m=badge.textContent.match(/(\d+(?:[.,]\d+)?)\s*%/);if(!m){badge.removeAttribute('data-buce-green-tier');return;}const n=Number(m[1].replace(',','.'));badge.dataset.buceGreenTier=n>=50?'extreme':n>=30?'strong':'soft';};
  paint();new MutationObserver(paint).observe(badge,{childList:true,subtree:true,characterData:true});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind,{once:true});else bind();
 document.addEventListener('shopify:section:load',bind);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buce-plantilla-cm"] && !Shopify.designMode) return;
  try {
    (() => {
  function resolveMeasure(records, variants, id) {
    const variant = variants.find(v => String(v.id) === String(id));
    if (!variant) return null;
    const record = records.find(r => String(r.id) === String(id));
    if (!record || record.sku !== variant.sku || variant.title.trim() !== 'EUR ' + record.eur) return null;
    return record;
  }
  function groupSizes(variants) {
    const sizes = variants.filter(v => /^EUR\s+\d+(?:[.,]\d+)?$/.test(v.title.trim()));
    const number = v => Number(v.title.trim().replace(/^EUR\s+/, '').replace(',', '.'));
    const sorted = [...sizes].sort((a, b) => number(a) - number(b));
    return { available: sorted.filter(v => v.available), soldout: sorted.filter(v => !v.available) };
  }
  if (typeof module === 'object' && module.exports) module.exports = { resolveMeasure, groupSizes };
  if (typeof customElements === 'undefined' || customElements.get('buce-plantilla-cm')) return;
  class PlantillaCm extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.form = this.closest('form');
      this.output = this.querySelector('[data-cm-value]');
      if (!this.form || !this.output) return;
      try {
        this.records = JSON.parse(this.dataset.cmRecords);
        this.variants = JSON.parse(this.dataset.cmVariants);
      } catch (_) { return; }
      this.bound = true;
      this.groups = groupSizes(this.variants);
      if (this.groups.available.length || this.groups.soldout.length) this.form.classList.add('buce-cm-form');
      this.decorate();
      this.onChange = () => queueMicrotask(() => this.update());
      this.onClick = event => {
        if (event.target.closest('[data-swatch-item], [data-dropdown-off]')) requestAnimationFrame(() => this.update());
      };
      this.onSubmit = event => {
        const selected = this.form.querySelector('select[name="id"], input[name="id"]:checked, input[type="hidden"][name="id"]');
        const selectedVariant = this.variants.find(v => String(v.id) === selected?.value);
        if ((!this.groups.available.length && this.groups.soldout.length) || (selectedVariant && !selectedVariant.available)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      };
      this.onTab = event => {
        const item = event.target.closest('[data-cm-size]');
        if (event.key !== 'Tab' || !item || item.dataset.cmHidden) return;
        const group = item.closest('[data-swatch-option]');
        const sizes = [...group.querySelectorAll('[data-cm-size]')].filter(e => !e.dataset.cmHidden && e.getAttribute('aria-disabled') !== 'true').sort((a,b) => Number(a.style.order) - Number(b.style.order));
        const next = sizes[sizes.indexOf(item) + (event.shiftKey ? -1 : 1)];
        if (next) { event.preventDefault(); next.focus(); return; }
        const all = [...document.querySelectorAll('a[href],button,input,select,textarea,summary,[tabindex]')].filter(e => e.tabIndex >= 0 && !e.disabled && e.getClientRects().length && getComputedStyle(e).visibility !== 'hidden');
        const inside = all.map((e,i) => group.contains(e) ? i : -1).filter(i => i >= 0);
        const outside = event.shiftKey ? all[Math.min(...inside)-1] : all[Math.max(...inside)+1];
        if (outside) { event.preventDefault(); outside.focus(); }
      };
      this.form.addEventListener('keydown', this.onTab);
      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('click', this.onClick);
      this.form.addEventListener('submit', this.onSubmit, true);
      this.update();
    }
    decorate() {
      if (this.decorated) return;
      this.decorated = true;
      // Keep native controls, their DOM order, IDs and event handlers. T4S uses
      // .find(...).eq(optionIndex): physically regrouping them breaks variants.
      const items = [...this.form.querySelectorAll('[data-swatch-item]')];
      for (const item of items) {
        const variant = this.variants.find(v => v.title === item.dataset.value);
        if (!variant || !/^EUR\s+\d/.test(variant.title)) continue;
        item.dataset.cmSize = 'true';
        item.style.order = String(Number(variant.title.replace(/^EUR\s+/, '').replace(',', '.')) * 100);
        if (!variant.available) { item.dataset.cmHidden = 'true'; continue; }
        this.appendMeasure(item, variant);
      }
      const labels = [...this.form.querySelectorAll('.buce-quick-buy__choice')];
      for (const label of labels) {
        const radio = this.form.querySelector('[id="' + label.htmlFor + '"]');
        const variant = this.variants.find(v => String(v.id) === radio?.value);
        if (!variant) continue;
        label.style.order = String(Number(variant.title.replace(/^EUR\s+/, '').replace(',', '.')) * 100);
        this.appendMeasure(label, variant);
      }
      const fieldset = this.form.querySelector('.buce-quick-buy__choices');
      if (fieldset) for (const variant of this.groups.available) {
        const radio = [...fieldset.querySelectorAll('input[name="id"]')].find(e => e.value === String(variant.id));
        const label = radio && labels.find(e => e.htmlFor === radio.id);
        if (radio && label) fieldset.append(radio, label);
      }
      for (const option of this.form.querySelectorAll('select[name="id"] option')) {
        const optionVariant = this.variants.find(v => String(v.id) === option.value);
        if (optionVariant && !optionVariant.available) option.hidden = true;
        const record = resolveMeasure(this.records, this.variants, option.value);
        if (record) option.textContent += ' · ' + String(record.cm).replace('.', ',') + ' cm';
      }
    }

    appendMeasure(control, variant) {
      const record = resolveMeasure(this.records, this.variants, variant.id);
      if (!record || control.querySelector('[data-cm-inline]')) return;
      const measure = document.createElement('span');
      measure.dataset.cmInline = 'true';
      measure.id = (this.form.getAttribute('id') || 'cm-' + this.dataset.productId) + '-cm-' + variant.id;
      measure.textContent = String(record.cm).replace('.', ',') + ' cm';
      control.appendChild(measure);
      control.setAttribute('aria-describedby', [control.getAttribute('aria-describedby'), measure.id].filter(Boolean).join(' '));
    }
    disconnectedCallback() {
      if (!this.bound) return;
      this.form.removeEventListener('keydown', this.onTab);
      this.form.removeEventListener('change', this.onChange);
      this.form.removeEventListener('click', this.onClick);
      this.form.removeEventListener('submit', this.onSubmit, true);
      this.bound = false;
    }
    update() {
      const input = this.form.querySelector('select[name="id"], input[name="id"]:checked, input[type="hidden"][name="id"]');
      const id = input && input.value;
      let text = 'Elige una talla para ver su medida de plantilla.';
      if (!this.groups.available.length && this.groups.soldout.length) {
        text = 'Este modelo está agotado por ahora';
        for (const button of this.form.querySelectorAll('[type="submit"]')) button.disabled = true;
      }
      else if (id) {
        const variant = this.variants.find(v => String(v.id) === String(id));
        const record = resolveMeasure(this.records, this.variants, id);
        if (variant && !variant.available) text = variant.title + ' · Talla agotada';
        else if (record) text = 'EUR ' + record.eur + ' · Plantilla: ' + String(record.cm).replace('.', ',') + ' cm';
        else if (variant) text = variant.title + ' · Medida de plantilla pendiente';
      }
      if (this.output.textContent !== text) this.output.textContent = text;
    }
  }
  customElements.define('buce-plantilla-cm', PlantillaCm);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buce-quick-buy"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.BuceV2QuickBuy) return;
  window.BuceV2QuickBuy = true;

  const syncPageLock = () => {
    document.documentElement.classList.toggle('buce-v2-quick-open', Boolean(document.querySelector('.buce-quick-buy__details[open]')));
  };

  const close = (details, restoreFocus = true) => {
    if (!details || !details.open) return;
    const panel = details.querySelector('.buce-quick-buy__panel');
    if (panel?.matches(':popover-open')) panel.hidePopover();
    details.open = false;
    syncPageLock();
    if (restoreFocus) {
      const summary = details.querySelector(':scope > summary');
      if (summary instanceof HTMLElement) window.setTimeout(() => summary.focus({ preventScroll: true }), 0);
    }
  };

  const positionPanel = (details) => {
    const panel = details.querySelector('.buce-quick-buy__panel');
    const summary = details.querySelector(':scope > summary');
    if (!panel || !summary || !details.open) return;
    panel.style.removeProperty('left');
    panel.style.removeProperty('top');
    panel.style.removeProperty('bottom');
    panel.style.removeProperty('right');
    if (window.matchMedia('(min-width: 768px)').matches) {
      const anchor = summary.getBoundingClientRect();
      const box = panel.getBoundingClientRect();
      const left = Math.max(12, Math.min(anchor.right - box.width, window.innerWidth - box.width - 12));
      const above = anchor.top - box.height - 8;
      const top = above >= 12 ? above : Math.max(12, Math.min(anchor.bottom + 8, window.innerHeight - box.height - 12));
      panel.style.left = left + 'px';
      panel.style.top = top + 'px';
    }
  };

  window.addEventListener('resize', () => {
    document.querySelectorAll('.buce-quick-buy__details[open]').forEach(positionPanel);
  });

  const focusDialog = (details) => {
    const selected = details.querySelector('.buce-quick-buy__radio:checked');
    const first = selected || details.querySelector('.buce-quick-buy__radio');
    const closeButton = details.querySelector('.buce-quick-buy__close');
    window.setTimeout(() => {
      if (first instanceof HTMLElement) first.focus({ preventScroll: true });
      else if (closeButton instanceof HTMLElement) closeButton.focus();
    }, 0);
  };

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.classList.contains('buce-quick-buy__details')) return;

    if (details.open) {
      document.querySelectorAll('.buce-quick-buy__details[open]').forEach((other) => {
        if (other !== details) close(other, false);
      });
      const panel = details.querySelector('.buce-quick-buy__panel');
      if (panel && !panel.matches(':popover-open')) panel.showPopover();
      positionPanel(details);
      focusDialog(details);
    } else {
      const panel = details.querySelector('.buce-quick-buy__panel');
      if (panel?.matches(':popover-open')) panel.hidePopover();
    }
    syncPageLock();
  }, true);

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const closer = target.closest('[data-buce-quick-close]');
    if (closer) {
      event.preventDefault();
      close(closer.closest('.buce-quick-buy__details'));
    }
    // El popover es manual: cerrar al tocar fuera, sin desplazar el carrusel.
    else {
      const opened = document.querySelector('.buce-quick-buy__details[open]');
      if (opened && !target.closest('.buce-quick-buy__panel,.buce-quick-buy__plus')) {
        close(opened, false);
      }
    }
  });

  // Direct-size response on the first completed pointer gesture. Native label semantics remain intact.
  document.addEventListener('pointerup', (event) => {
    if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
    const label = event.target instanceof Element ? event.target.closest('.buce-quick-buy__panel label.buce-quick-buy__choice') : null;
    if (!(label instanceof HTMLLabelElement)) return;
    const panel = label.closest('.buce-quick-buy__panel:popover-open');
    if (!panel) return;
    const id = label.getAttribute('for');
    const input = id ? document.getElementById(id) : null;
    if (!(input instanceof HTMLInputElement) || input.disabled || input.checked) return;
    input.checked = true;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, { passive: true });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('buce-quick-buy')) return;

    event.preventDefault();
    if (form.dataset.buceSubmitting === '1') return;

    const selected = form.querySelector('input[name="id"]:checked, select[name="id"], input[type="hidden"][name="id"]');
    if (!(selected instanceof HTMLInputElement || selected instanceof HTMLSelectElement) || !selected.value) {
      form.querySelector('.buce-quick-buy__radio')?.focus();
      return;
    }

    const submit = event.submitter instanceof HTMLButtonElement
      ? event.submitter
      : form.querySelector('button[type="submit"]');
    const details = form.querySelector('.buce-quick-buy__details');

    form.dataset.buceSubmitting = '1';
    form.setAttribute('aria-busy', 'true');
    if (submit instanceof HTMLButtonElement) submit.disabled = true;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('Quick Add HTTP ' + response.status);
      const item = await response.json();

      const cartResponse = await fetch(root + 'cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!cartResponse.ok) throw new Error('Cart HTTP ' + cartResponse.status);
      const cart = await cartResponse.json();

      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = String(cart.item_count || 0);
        node.classList.toggle('t4s-op-0', !(cart.item_count > 0));
      });

      close(details, false);
      document.dispatchEvent(new CustomEvent('buce:quick-add-success', {
        detail: { item, cart }
      }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      window.BuceCartUI?.refresh?.();

      // La compra continua en la pagina; el cliente decide cuando abrir el carrito.
    } catch (error) {
      document.dispatchEvent(new CustomEvent('buce:quick-add-error', { detail: { error } }));
      console.error('[Buce Quick Add]', error);
    } finally {
      form.dataset.buceSubmitting = '0';
      form.removeAttribute('aria-busy');
      if (submit instanceof HTMLButtonElement) submit.disabled = false;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('.buce-quick-buy__details[open]');
    if (open) {
      event.preventDefault();
      close(open);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buce-scroll-dots"] && !Shopify.designMode) return;
  try {
    function buceScrollDots(){
 document.querySelectorAll('[data-buce-scroll-dots]').forEach(function(dots){
  if(dots.dataset.bound)return;
  var track=document.getElementById(dots.dataset.trackId);if(!track)return;
  dots.dataset.bound='true';var positions=[],frame=0;
  function sync(){frame=0;var at=positions.reduce(function(best,value,i){return Math.abs(value-track.scrollLeft)<Math.abs(positions[best]-track.scrollLeft)?i:best;},0);Array.from(dots.children).forEach(function(button,i){button.setAttribute('aria-current',String(i===at));});}
  function build(){
   var max=Math.max(0,track.scrollWidth-track.clientWidth);positions=[];
   if(max>2){
    if(track.dataset.buceScrollMode==='slides'){var first=track.children[0];positions=Array.from(track.children).map(function(slide){return Math.min(max,Math.max(0,slide.offsetLeft-first.offsetLeft));});}
    else{positions.push(0);for(var left=track.clientWidth;left<max-Math.min(24,track.clientWidth*.08);left+=Math.max(1,track.clientWidth))positions.push(left);positions.push(max);}
   }
   positions=positions.filter(function(value,i,all){return i===0||Math.abs(value-all[i-1])>2;});
   dots.hidden=positions.length<2;dots.replaceChildren();
   positions.forEach(function(left,i){var button=document.createElement('button');button.type='button';button.setAttribute('aria-label',dots.dataset.pageLabel.replace('__INDEX__',String(i+1)).replace('__TOTAL__',String(positions.length)));button.setAttribute('aria-controls',track.id);button.addEventListener('click',function(){track.scrollTo({left:left,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});});dots.append(button);});sync();
  }
  track.addEventListener('scroll',function(){if(!frame)frame=requestAnimationFrame(sync);},{passive:true});
  if(window.ResizeObserver)new ResizeObserver(build).observe(track);else window.addEventListener('resize',build);
  track.addEventListener('load',build,true);build();
 });
}
buceScrollDots();document.addEventListener('DOMContentLoaded',buceScrollDots);document.addEventListener('shopify:section:load',buceScrollDots);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buce-shipping-badge"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('buce-shipping-included')) return;
  customElements.define('buce-shipping-included', class extends HTMLElement {
    connectedCallback() {
      if (this.positioned) return;
      const scope = this.closest('[data-product-featured]') || this.closest('.shopify-section');
      if (!scope) return;
      const price = scope.querySelector('.t4s-product__price-review .t4s-price-stock') || scope.querySelector('.t4s-product__info-container .t4s-product-price');
      if (!price || price.contains(this)) return;
      this.positioned = true;
      price.after(this);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buce-smart-stock"] && !Shopify.designMode) return;
  try {
    (() => {
 function initStock(root){
  if(root.dataset.stockInitialized==='true')return;
  const data=root.querySelector('[data-buce-stock-variants]'),message=root.querySelector('[data-buce-stock-message]');
  if(!data||!message)return;
  let variants;try{variants=JSON.parse(data.textContent||'[]');}catch{return;}
  if(!Array.isArray(variants))return;
  root.dataset.stockInitialized='true';
  const byId=new Map(variants.map(variant=>[String(variant.id),variant]));
  const host=root.closest('[data-product-featured]')||root.closest('.shopify-section')||document;
  let chip=null;
  function imageStock(copy){
   const rail=host.querySelector('.t4s-single-product-badge');
   if(!rail)return;
   if(!chip||!chip.isConnected){chip=rail.querySelector('[data-buce-pdp-stock]');if(!chip){chip=document.createElement('span');chip.className='t4s-badge-item buce-pdp-stock';chip.setAttribute('data-buce-pdp-stock','');rail.append(chip);}}
   chip.textContent=copy||'';chip.hidden=!copy;
  }
  function hide(){root.hidden=true;message.textContent='';root.classList.remove('is-critical','is-low','is-ok','is-soldout','is-last-pairs');imageStock('');}
  function paint(id){
   const variant=byId.get(String(id||'')),qty=Number(variant?.qty);
   if(!variant||!variant.available||variant.tracked!==true||variant.policy!=='deny'||!Number.isInteger(qty)||qty<1||qty>5){hide();return;}
   const base=qty===1?root.dataset.stockOne:root.dataset.stockMany.replace('__COUNT__',String(qty));
   const title=variant.title&&variant.title!=='Default Title'?variant.title.replace(/^EUR\s*/i,root.dataset.stockSize+' '):'';
   message.textContent=base+(title?' \u00b7 '+title:'')+'. '+root.dataset.stockNudge;
   imageStock(base+(title?' \u00b7 '+title:''));
   root.classList.toggle('is-critical',qty<=2);root.classList.toggle('is-low',qty>2);root.hidden=false;
  }
  function synchronize(){const control=Array.from(host.querySelectorAll('form[action*="/cart/add"] [name="id"]')).find(input=>!input.closest('.buce-quick-buy,[data-buce-complement]')&&byId.has(String(input.value)));if(control)paint(control.value);}
  paint(root.dataset.initialVariant);
  document.addEventListener('change',event=>{const target=event.target;if(!(target instanceof Element)||target.getAttribute('name')!=='id'||target.closest('.buce-quick-buy,[data-buce-complement]'))return;if(byId.has(String(target.value)))paint(target.value);else if(host.contains(target))hide();});
  ['variant:changed','variant:change','product:variant-change'].forEach(name=>document.addEventListener(name,event=>{const variant=event.detail?.variant||event.detail?.currentVariant||event.detail;if(variant?.id&&byId.has(String(variant.id)))paint(variant.id);}));
  host.addEventListener('click',event=>{if(!(event.target instanceof Element)||!event.target.closest('.t4s-swatch__item,[data-swatch-item],.pp-option-value'))return;window.setTimeout(synchronize,100);window.setTimeout(synchronize,350);});
  if(window.jQuery)window.jQuery(document).on('variant:changed','[data-product-featured]',function(event){if(event.currentVariant?.id&&byId.has(String(event.currentVariant.id)))paint(event.currentVariant.id);});
 }
 const initialize=()=>document.querySelectorAll('[data-buce-smart-stock]').forEach(initStock);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
 document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buce-v10-commerce"] && !Shopify.designMode) return;
  try {
    (() => {
 'use strict';
 if (window.buceV10CommerceLoaded) return;
 window.buceV10CommerceLoaded = true;
 const ui = document.querySelector('buce-v10-commerce');
 if (!ui) return;
 let last = null, cached = null, dock = null, timer = 0, version = 0, controller = null;
 let pendingAddUntil = 0, feedbackUntil = 0, feedbackText = '', screenFrame = 0, stale = true;
 const observed = new WeakSet(), chatOriginal = new WeakMap();
 const integer = value => Number.parseInt(value || '0', 10) || 0;
 const read = node => ({items:integer(node.dataset.buceItemCount), total:integer(node.dataset.buceTotal), saving:integer(node.dataset.buceSaving), discount:integer(node.dataset.buceDiscount), shoes:integer(node.dataset.buceShoes), free:node.dataset.buceFreeApplied === 'true', wholesale:node.dataset.buceWholesale === 'true', promotable:node.dataset.buceHasCode !== 'true' && (node.dataset.buceExclusive !== 'true' || node.dataset.buceFreeApplied === 'true')});
 const visible = node => !!(node && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
 const own = '[data-buce-v8-info],[data-buce-v2-fixed-saving],[data-buce-v10-sticky],.buce-cro-confetti';
 function emit(name, detail) { document.dispatchEvent(new CustomEvent(name,{detail})); }
 function publish() { if (cached) emit('buce:cart-status',{state:cached.cloneNode(true), version}); }
 function chatNodes() {
  const found = new Set();
  document.querySelectorAll('#revie-whatsapp-wrapper,[id*="whatsapp" i],a[href*="wa.me"],a[href*="api.whatsapp.com"],iframe[title*="whatsapp" i]').forEach(candidate => {
   let node = candidate;
   for (let depth=0; node && depth<6; depth++,node=node.parentElement) {
    if (getComputedStyle(node).position === 'fixed') { found.add(node); break; }
   }
  });
  return [...found];
 }
 function restoreChat(node) {
  const before = chatOriginal.get(node);
  if (!before) return;
  for (const key of ['bottom','visibility']) {
   if (before[key].value) node.style.setProperty(key,before[key].value,before[key].priority);
   else node.style.removeProperty(key);
  }
 }
 function syncScreen() {
  screenFrame = 0;
  const drawer = [...document.querySelectorAll('.t4s-drawer[aria-hidden="false"],.t4s-drawer.is--opened,dialog[open],[role="dialog"][aria-modal="true"]:not([hidden]),.mfp-wrap')].some(visible);
  const active = document.activeElement;
  const editing = active?.matches('input:not([type="button"]):not([type="submit"]):not([type="checkbox"]):not([type="radio"]),textarea,[contenteditable="true"]');
  const keyboard = !!(editing && window.visualViewport && window.visualViewport.height < window.innerHeight * .78);
  const chat = chatNodes();
  const chatOpen = chat.some(node => {const r=node.getBoundingClientRect();return visible(node)&&r.width>180&&r.height>180;});
  const hide = stale || !dock || !last?.items || drawer || keyboard || chatOpen || document.body.classList.contains('template-cart');
  const previewBar = [...document.querySelectorAll('#PBarNextFrameWrapper,#preview-bar-iframe,#ShopifyPreviewBar,iframe[title*="preview" i]')].find(node => {const r=node.getBoundingClientRect();return visible(node)&&r.height<=140&&r.bottom>=innerHeight-3;});
  const previewSpace = previewBar ? Math.ceil(previewBar.getBoundingClientRect().height) : 0;
  document.documentElement.style.setProperty('--buce-cro-preview-space',previewSpace+'px');
  if (dock) dock.hidden = hide;
  document.body.classList.toggle('buce-v14-drawer-open',drawer);
  document.body.classList.toggle('buce-cro-dock-visible',!hide);
  const toolbar = document.querySelector('.t4s-toolbar');
  const toolbarSpace = visible(toolbar) ? Math.ceil(toolbar.getBoundingClientRect().height)+18 : 0;
  document.body.classList.toggle('buce33-action-hidden',drawer||keyboard||chatOpen);
  document.body.classList.toggle('buce-discovery-nav-hidden',drawer||keyboard||chatOpen);
  const nativeAction=document.querySelector('.t4s-sticky-atc');
  const nativeActive=hide&&!drawer&&!keyboard&&!chatOpen&&visible(nativeAction)&&Number.parseFloat(getComputedStyle(nativeAction).opacity)>0;
  const activeAction=!hide?dock:nativeActive?nativeAction:null;
  const actionHeight=activeAction?Math.ceil(activeAction.getBoundingClientRect().height):0;
  const actionBottom=visible(toolbar)?Math.ceil(innerHeight-toolbar.getBoundingClientRect().top)+8:previewSpace+10;
  document.documentElement.style.setProperty('--buce-action-bottom',actionBottom+'px');
  document.documentElement.style.setProperty('--buce-action-reserve',(actionBottom+actionHeight+16)+'px');
  const height = actionHeight? actionHeight+22+previewSpace : 0;
  document.documentElement.style.setProperty('--buce-cro-dock-space',height+'px');
  chat.forEach(node => {
   if (!chatOriginal.has(node)) {
    const before={};
    for (const key of ['bottom','visibility']) before[key]={value:node.style.getPropertyValue(key),priority:node.style.getPropertyPriority(key)};
    chatOriginal.set(node,before);
   }
   restoreChat(node);
   const r=node.getBoundingClientRect();
   if (drawer && r.width<=180 && r.height<=180) node.style.setProperty('visibility','hidden','important');
   else if (r.width<=180 && r.height<=180 && (!hide || toolbarSpace)) node.style.setProperty('bottom',(height+toolbarSpace+12)+'px','important');
  });
  paintFeedback();
 }
 function scheduleScreen() { if (!screenFrame) screenFrame=requestAnimationFrame(syncScreen); }
 function paintFeedback() {
  const drawerOpen=document.body.classList.contains('buce-v14-drawer-open');
  document.querySelectorAll('[data-buce-cro-feedback]').forEach(node => {
   const inDock=!!node.closest('[data-buce-v10-sticky]');
   const inDrawer=!!node.closest('#t4s-mini_cart');
   const show=Date.now()<feedbackUntil && ((drawerOpen&&inDrawer)||(!drawerOpen&&inDock));
   if (show && node.textContent!==feedbackText) node.textContent=feedbackText;
   node.hidden=!show;
  });
 }
 function confetti() {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('.buce-cro-confetti').forEach(node=>node.remove());
  const anchor=[...document.querySelectorAll('[data-buce-cro-feedback]')].find(visible);
  if (!anchor) return;
  const r=anchor.getBoundingClientRect(), host=document.createElement('div');
  host.className='buce-cro-confetti';host.setAttribute('aria-hidden','true');
  host.style.left=Math.max(0,Math.min(innerWidth-300,r.left+r.width/2-150))+'px';
  host.style.top=Math.max(0,r.top-35)+'px';
  for(let i=0;i<14;i++) {const bit=document.createElement('i');bit.style.setProperty('--x',(Math.random()*260-130)+'px');bit.style.setProperty('--r',(Math.random()*180)+'deg');bit.style.setProperty('--h',String(100+Math.floor(Math.random()*80)));host.append(bit);}
  document.body.append(host);setTimeout(()=>host.remove(),1000);
 }
 function announce(previous,next) {
  if(window.BuceAH&&next.shoes>previous?.shoes)return; // AH owns shoe reward delivery; native complement confirmation stays.
  if (!previous || Date.now()>pendingAddUntil || next.items<=previous.items) return;
  pendingAddUntil=0;
  const shoeAdded=next.shoes>previous.shoes;
  feedbackText=!previous.free&&next.free ? ui.dataset.freeApplied : shoeAdded ? ui.dataset.added : ui.dataset.addedGeneric;
  feedbackUntil=Date.now()+2400;
  paintFeedback();
  if (shoeAdded) requestAnimationFrame(confetti);
  setTimeout(()=>{paintFeedback();scheduleScreen();},2450);
 }
 function mount(state,next) {
  const previousFocus=dock?.contains(document.activeElement);
  const template=state.querySelector('template[data-buce-v10-sticky-template]');
  const replacement=template?.content.firstElementChild?.cloneNode(true);
  if (dock) dock.remove();
  dock=next.items>0&&replacement ? replacement : null;
  if (dock) {document.body.append(dock);if(previousFocus)dock.querySelector('[data-buce-view-cart]')?.focus({preventScroll:true});}
  document.body.classList.toggle('buce-v10-cart-ready',next.items>0);
  document.querySelectorAll('[data-cart-count]').forEach(node=>{if(Number(node.textContent)!==next.items)node.textContent=String(next.items);node.classList.toggle('t4s-op-0',next.items===0);});
  const cartLink=document.querySelector('.t4s-toolbart-cart>a'),cartLabel=cartLink?.querySelector('.t4s-toolbar-label');if(cartLabel){if(!cartLabel.dataset.baseLabel)cartLabel.dataset.baseLabel=cartLabel.textContent;cartLabel.textContent=next.items>0?ui.dataset.activeCartLabel:cartLabel.dataset.baseLabel;cartLink.setAttribute('aria-label',cartLabel.textContent+(next.items>0?', '+next.items+' productos':''));}
  paintBenefit();syncScreen();
 }
 function paintBenefit() {
  const benefit=dock?.querySelector('[data-buce-dock-benefit]'),state=window.BuceAH?.state();
  if(!benefit)return;
  const show=!!(state?.confirmed&&state.pairs>0&&!last?.wholesale&&last?.promotable);
  benefit.hidden=!show;
  if(show){
   const message=benefit.querySelector('[data-buce-dock-message]');message.textContent=window.BucePolish?.copy(state).next||state.next||state.current;
   const track=benefit.querySelector('[role="progressbar"]');track.setAttribute('aria-valuenow',String(Math.min(6,state.pairs)));track.setAttribute('aria-valuetext',message.textContent);
   track.querySelector('i').style.width=(Math.min(6,state.pairs)*100/6)+'%';
   track.querySelectorAll('[data-buce-dock-step]').forEach(step=>{const n=Number(step.dataset.buceDockStep);step.classList.toggle('is-done',n<=Math.min(6,state.pairs));step.classList.toggle('is-current',n===Math.min(6,state.pairs));});
  }
  scheduleScreen();
 }
 document.addEventListener('buce:ah-state',paintBenefit);
 document.addEventListener('buce:cart-loading',()=>{const benefit=dock?.querySelector('[data-buce-dock-benefit]');if(benefit)benefit.hidden=true;});
 function observe() {
  document.querySelectorAll('.t4s-count-box,[data-cart-count]').forEach(node=>{
   if(observed.has(node))return;observed.add(node);
   new MutationObserver(()=>schedule(140)).observe(node,{childList:true,subtree:true,characterData:true});
  });
  document.querySelectorAll('.t4s-drawer').forEach(node=>{
   if(observed.has(node))return;observed.add(node);
   new MutationObserver(scheduleScreen).observe(node,{attributes:true,attributeFilter:['aria-hidden','class']});
  });
 }
 async function refresh() {
  const request=++version;controller?.abort();controller=new AbortController();
  const currentController=controller;
  const timeout=setTimeout(()=>currentController.abort(),7000);
  emit('buce:cart-loading',{});
  try {
   const url=new URL(window.Shopify?.routes?.root||'/',location.origin);
   url.searchParams.set('section_id','buce-v8-cart-status');
   const preview=new URLSearchParams(location.search).get('preview_theme_id');
   if(preview)url.searchParams.set('preview_theme_id',preview);
   const cartUrl=new URL((window.Shopify?.routes?.root||'/')+'cart.js',location.origin);
   const [response,jsonResponse]=await Promise.all([fetch(url,{credentials:'same-origin',cache:'no-store',signal:currentController.signal}),fetch(cartUrl,{credentials:'same-origin',cache:'no-store',signal:currentController.signal})]);
   if(!response.ok)throw new Error('Cart status HTTP '+response.status);
   const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
   if(request!==version)return;
   const state=parsed.querySelector('[data-buce-v8-status]');
   if(!state || state.textContent.includes('Translation missing:'))throw new Error('Invalid cart status');
   const identity=await jsonResponse.json();if(request!==version)return;
   if(!jsonResponse.ok||identity.total_price!==integer(state.dataset.buceTotal)||identity.item_count!==integer(state.dataset.buceItemCount))throw new Error('Cart snapshots not reconciled');
   const ahSource=state.querySelector('[data-buce-ah-cart]');
   if(ahSource){
    const ah=JSON.parse(ahSource.textContent);
    const fingerprint=items=>JSON.stringify(items.map(i=>[Number(i.id),Number(i.quantity),Number(i.original_price),Number(i.original_line_price),Number(i.final_line_price),(i.allocations||i.line_level_discount_allocations||[]).map(a=>[a.title||a.discount_application?.title,Number(a.amount)]).sort((a,b)=>String(a[0]).localeCompare(String(b[0])))]).sort((a,b)=>JSON.stringify(a).localeCompare(JSON.stringify(b))));
    if(fingerprint(ah.items)!==fingerprint(identity.items))throw new Error('Cart lines not reconciled');
    ah.token=identity.token;ahSource.textContent=JSON.stringify(ah);
   }
   const previous=last,next=read(state);
   const changed=!cached||cached.outerHTML!==state.outerHTML;
   last=next;cached=state.cloneNode(true);stale=false;
   if(changed)mount(state,next);else scheduleScreen();
   publish();observe();announce(previous,next);
   if(dock){dock.removeAttribute('aria-busy');const button=dock.querySelector('button[name="checkout"]');if(button)button.disabled=false;}
  } catch(error) {
   if(request===version){stale=true;emit('buce:cart-error',{});if(dock){dock.hidden=true;document.body.classList.remove('buce-cro-dock-visible');}console.warn('[Buce cart]',error.message);}
  } finally {clearTimeout(timeout);}
 }
 function schedule(delay=220) {version++;controller?.abort();clearTimeout(timer);if(dock){dock.setAttribute('aria-busy','true');const button=dock.querySelector('button[name="checkout"]');if(button)button.disabled=true;}timer=setTimeout(refresh,delay);}
 window.BuceCartUI={refresh:()=>schedule(80),replay:publish};
 document.addEventListener('buce:cart-refresh',()=>schedule(180));
 document.addEventListener('click',event=>{
  if(!(event.target instanceof Element))return;
  if(event.target.closest('[data-action-atc],[data-atc-form],.buce-quick-buy button[type="submit"]')){pendingAddUntil=Date.now()+8000;schedule(750);}
  if(event.target.closest('.t4s-quantity-cart-item button,.t4s-mini_cart__remove,[data-cart-remove]'))schedule(700);
  if(event.target.closest('[data-drawer-options],[data-sidebar-id],.t4s-drawer__close'))setTimeout(scheduleScreen,100);
 });
 document.addEventListener('submit',event=>{
  if(event.target.matches('form[action*="/cart/add"]')){pendingAddUntil=Date.now()+8000;schedule(750);}
  if(event.target.closest('[data-buce-v10-sticky]')){
   const agreement=document.querySelector('#t4s-mini_cart .t4s-cart__agree input[type="checkbox"]');
   if(agreement&&!agreement.checked){event.preventDefault();location.assign(ui.dataset.cartUrl);}
  }
 });
 document.addEventListener('change',event=>{if(event.target.matches('[data-quantity-value],input[name="updates[]"]'))schedule(700);});
 ['cart:updated','cart:refresh','cart:change','product:added','t4s:cart:updated'].forEach(name=>document.addEventListener(name,()=>schedule(160)));
 document.addEventListener('shopify:section:load',()=>{observe();schedule(100);});
 window.addEventListener('pageshow',event=>{if(event.persisted){pendingAddUntil=0;schedule(80);}});
 document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible'){pendingAddUntil=0;schedule(100);}});
 window.addEventListener('resize',scheduleScreen,{passive:true});
 window.addEventListener('scroll',scheduleScreen,{passive:true});
 window.visualViewport?.addEventListener('resize',scheduleScreen,{passive:true});
 document.addEventListener('focusin',scheduleScreen);
 document.addEventListener('focusout',scheduleScreen);
 if(window.PerformanceObserver){try{new PerformanceObserver(list=>{if(list.getEntries().some(e=>/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(e.name)))schedule(350);}).observe({type:'resource',buffered:false});}catch(error){}}
 function start(){observe();refresh();new MutationObserver(scheduleScreen).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','hidden']});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buce-v2-event-hooks"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.BuceV2Events) return;

  const emit = (name, props = {}) => {
    document.dispatchEvent(new CustomEvent('buce:v2-event', {
      detail: {
        name,
        props: {
          ...props,
          page_type: document.body?.className.match(/template-([^\s]+)/)?.[1] || ''
        }
      }
    }));
  };

  const productContext = (target) => {
    const card = target.closest?.('.t4s-product[data-product-options]');
    if (!card) return {};
    try {
      const data = JSON.parse(card.getAttribute('data-product-options') || '{}');
      return { product_id: String(data.id || ''), product_handle: data.handle || '' };
    } catch {
      return {};
    }
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const toolbar = target.closest('.t4s-toolbar-item');
    if (toolbar) {
      const type = [...toolbar.classList].find((item) => item.startsWith('t4s-toolbart-'))?.replace('t4s-toolbart-', '') || '';
      emit('navigation_click', { destination: type });
    }

    const searchIntentTrigger = target.closest('[data-buce-search-intent], .t4s-toolbart-search');
    if (searchIntentTrigger) {
      const intent = searchIntentTrigger.getAttribute('data-buce-search-intent') || 'direct';
      const source = target.closest('[data-buce-v2-collection-hub]') ? 'collection_hub' : target.closest('[data-buce-v2-categories]') ? 'home_category' : target.closest('[data-buce-empty-finder]') ? 'empty_cart' : target.closest('.t4s-toolbar-item') ? 'bottom_nav' : 'header';
      emit(intent === 'guided' ? 'finder_open' : 'search_open', { source });

      window.setTimeout(() => {
        const drawer = document.querySelector('#t4s-search-hidden');
        const form = drawer?.querySelector('[data-frm-search]');
        const input = form?.querySelector('[data-input-search]');
        if (!drawer || !form) return;

        if (intent === 'direct') {
          if (form.classList.contains('buce-guided') && !document.querySelector('[data-buce-finder-context]')?.getAttribute('data-buce-finder-context')) {
            drawer.querySelector('[data-buce-restart]')?.click();
          }
          const direct = drawer.querySelector('[data-buce-direct-search]');
          if (input instanceof HTMLElement && document.activeElement !== input && !drawer.contains(document.activeElement)) {
            direct?.scrollIntoView?.({ block: 'start' });
            input.focus({ preventScroll: true });
          }
        } else {
          if (input instanceof HTMLInputElement) {
            const hadQuery = input.value.length > 0;
            input.value = '';
            if (hadQuery) input.dispatchEvent(new Event('input', { bubbles: true }));
            input.blur();
          }
          const autoKind = searchIntentTrigger.getAttribute('data-buce-kind-auto');
          if (autoKind) {
            const kindButton = drawer.querySelector('[data-buce-kind="' + autoKind + '"]');
            if (kindButton instanceof HTMLElement) kindButton.click();
          } else {
            const guided = drawer.querySelector('[data-buce-finder-welcome], [data-buce-kind-step]');
            guided?.scrollIntoView?.({ block: 'start' });
          }
        }
      }, 180);
    }

    const finderKind = target.closest('[data-buce-kind]');
    if (finderKind) emit('finder_category_selected', { category: finderKind.getAttribute('data-buce-kind') || '' });

    const finderSize = target.closest('[data-buce-shoe-size],[data-buce-shirt-size]');
    if (finderSize) emit('finder_size_selected', { size: finderSize.getAttribute('data-buce-shoe-size') || finderSize.getAttribute('data-buce-shirt-size') || '' });

    const finderBrand = target.closest('[data-buce-brand]');
    if (finderBrand) emit('finder_brand_selected', { brand: finderBrand.getAttribute('data-buce-brand-label') || finderBrand.getAttribute('data-buce-brand') || '' });

    const quick = target.closest('.buce-quick-buy__details > summary');
    if (quick) emit('quick_add_open', productContext(quick));

    const cardLink = target.closest('.t4s-product [data-pr-href], .t4s-product .t4s-product-title a');
    if (cardLink) emit('product_card_click', { ...productContext(cardLink), href: cardLink.getAttribute('href') || '' });

    const hubLink = target.closest('[data-buce-v2-collection-hub] a');
    if (hubLink) emit('collection_hub_click', { href: hubLink.getAttribute('href') || '', label: (hubLink.textContent || '').trim().slice(0, 60) });

    const recent = target.closest('.buce-v2-recent-card');
    if (recent) emit('recent_product_click', { href: recent.getAttribute('href') || '' });

    const cartTrigger = target.closest('.t4s-toolbart-cart, [data-drawer-options*="t4s-mini_cart"]');
    if (cartTrigger) emit('cart_open', { source: target.closest('.t4s-toolbar-item') ? 'bottom_nav' : 'page' });
  });

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (target.classList.contains('buce-quick-buy__radio') && target.checked) {
      emit('quick_add_variant_selected', { ...productContext(target), variant_id: target.value });
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.classList.contains('buce-quick-buy')) {
      const selected = form.querySelector('input[name="id"]:checked, select[name="id"], input[type="hidden"][name="id"]');
      emit('quick_add_submit', { ...productContext(form), variant_id: selected?.value || '' });
    }

    if (form.matches('[data-frm-search], form[action*="/search"]')) {
      const input = form.querySelector('input[name="q"]');
      emit('search_submit', { query_length: String(input?.value || '').trim().length });
    }

    if (form.querySelector('[name="checkout"]') || event.submitter?.getAttribute?.('name') === 'checkout') {
      emit('checkout_started', { source: form.closest('#t4s-mini_cart') ? 'mini_cart' : 'cart_page' });
    }
  });

  window.BuceV2Events = { emit };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buce-v2-pdp"] && !Shopify.designMode) return;
  try {
    (() => {
 const start=()=>{
  const template=document.querySelector('template[data-buce-feedback-benefits]');
  const media=document.querySelector('#MainContent .t4s-product__media-wrapper');
  const info=document.querySelector('#MainContent .t4s-product__info-container');
  if(!template||!media||!info||media.querySelector('.buce-feedback-benefits'))return;
  const row=template.content.firstElementChild.cloneNode(true);
  media.prepend(row);
  const discount=row.querySelector('[data-buce-feedback-discount]');
  const shipping=row.querySelector('[data-buce-feedback-shipping]');
  const amount=node=>Number((node?.textContent||'').replace(/[^0-9]/g,''));
  const update=()=>{
   const price=info.querySelector('.t4s-product-price');
   const current=amount(price?.querySelector('ins'));
   const previous=amount(price?.querySelector('del'));
   const hasDiscount=current>0&&previous>current;
   discount.hidden=!hasDiscount;
   if(hasDiscount)discount.textContent='−'+Math.round((previous-current)*100/previous)+'% OFF';
   shipping.hidden=!info.querySelector('buce-shipping-included strong');
   row.hidden=discount.hidden&&shipping.hidden;
  };
  update();
  new MutationObserver(update).observe(info,{childList:true,subtree:true,characterData:true});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buce-v2-recently-viewed"] && !Shopify.designMode) return;
  try {
    (() => {
  const key = 'buce:v2:recent';
  const maxItems = 10;
  const maxAge = 1000 * 60 * 60 * 24 * 14;

  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(value)) return [];
      const now = Date.now();
      return value.filter((item) => item && item.handle && now - Number(item.seenAt || 0) <= maxAge).slice(0, maxItems);
    } catch {
      return [];
    }
  };

  const write = (items) => {
    try {
      localStorage.setItem(key, JSON.stringify(items.slice(0, maxItems)));
    } catch {}
  };

  const source = document.querySelector('[data-buce-v2-recent-current]');
  if (source) {
    try {
      const item = JSON.parse(source.textContent || '{}');
      if (item.handle) {
        const items = read().filter((entry) => entry.handle !== item.handle);
        item.seenAt = Date.now();
        items.unshift(item);
        write(items);
      }
    } catch {}
  }

  const root = document.querySelector('[data-buce-v2-recent]');
  const rail = root?.querySelector('[data-buce-v2-recent-rail]');
  if (!root || !rail) return;
  // Keep browsing history inside the home content, before the footer.
  document.querySelector('#MainContent')?.appendChild(root);

  const money = (value, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-CO', {
        style: 'currency',
        currency: currency || 'COP',
        maximumFractionDigits: 0
      }).format((Number(value) || 0) / 100);
    } catch {
      return '$' + Math.round((Number(value) || 0) / 100).toLocaleString('es-CO');
    }
  };

  const render = () => {
    const items = read();
    rail.replaceChildren();
    if (!items.length) {
      root.hidden = true;
      return;
    }

    const fragment = document.createDocumentFragment();
    items.slice(0, 8).forEach((item) => {
      const link = document.createElement('a');
      link.className = 'buce-v2-recent-card';
      link.href = item.url || ('/products/' + encodeURIComponent(item.handle));

      const media = document.createElement('span');
      media.className = 'buce-v2-recent-card__media';
      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        media.appendChild(img);
      }

      const body = document.createElement('span');
      body.className = 'buce-v2-recent-card__body';

      const title = document.createElement('strong');
      title.className = 'buce-v2-recent-card__title';
      title.textContent = item.title || '';

      const price = document.createElement('span');
      price.className = 'buce-v2-recent-card__price';
      const current = document.createElement('b');
      current.textContent = money(item.price, item.currency);
      price.appendChild(current);
      if (Number(item.compare) > Number(item.price)) {
        const compare = document.createElement('del');
        compare.textContent = money(item.compare, item.currency);
        price.appendChild(compare);
      }

      body.append(title, price);
      if (item.shipping && !/^medias\b/i.test(item.title || '')) {
        const shipping = document.createElement('small');
        shipping.className = 'buce-v2-recent-card__shipping';
        shipping.textContent = root.dataset.shippingLabel || 'Envío incluido';
        body.appendChild(shipping);
      }

      link.append(media, body);
      fragment.appendChild(link);
    });

    rail.appendChild(fragment);
    root.hidden = false;
  };

  root.dataset.shippingLabel = document.documentElement.lang?.toLowerCase().startsWith('en') ? 'Shipping included' : 'Envío incluido';
  root.querySelector('[data-buce-v2-recent-clear]')?.addEventListener('click', () => {
    try { localStorage.removeItem(key); } catch {}
    render();
  });
  render();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buce-v8-checkout-focus"] && !Shopify.designMode) return;
  try {
    (() => {
 'use strict';
 if(window.buceV8CheckoutFocusLoaded)return;
 window.buceV8CheckoutFocusLoaded=true;
 const selector='#t4s-mini_cart button[name="checkout"],.t4s-cartPage__form button[name="checkout"]';
 const own='[data-buce-v8-info],[data-buce-v2-fixed-saving],[data-buce-v2-extras],[data-buce-cro-polished],[data-buce-cart-motivation-mount],[data-buce-ah-mount],[data-buce-cart-companion]';
 const observed=new WeakSet(),renderedStatus=new WeakMap();let prepareTimer=0;
 function savingsMount(root){
  const mounts=[...root.querySelectorAll('[data-buce-ah-mount]')];
  const ah=mounts.find(node=>node.parentElement?.matches('.t4s-drawer__bottom'))||mounts[0]||document.createElement('div');
  ah.setAttribute('data-buce-ah-mount','');
  mounts.forEach(node=>{if(node!==ah)node.remove();});
  return ah;
 }
 function request(){document.dispatchEvent(new CustomEvent('buce:cart-refresh'));}
 function prepare(){
  const root=document.getElementById('t4s-mini_cart');
  const bottom=root?.querySelector('.t4s-drawer__bottom');
  const scroll=root?.querySelector('.t4s-drawer__main .t4s-drawer__scroll');
  const button=bottom?.querySelector('button[name="checkout"]');
  if(!root||!bottom||!scroll||!button)return;
  let info=root.querySelector('[data-buce-v8-info]');
  if(!info){info=document.createElement('div');info.dataset.buceV8Info='';info.hidden=true;}
  const items=scroll.querySelector('[data-cart-items]');
  let motivation=root.querySelector('[data-buce-cart-motivation-mount]');
  if(!motivation){motivation=document.createElement('div');motivation.dataset.buceCartMotivationMount='';motivation.hidden=true;}
  if(items&&motivation.nextElementSibling!==items)items.before(motivation);else if(!items&&motivation.parentElement!==scroll)scroll.prepend(motivation);
  if(items&&items.nextElementSibling!==info)items.after(info);else if(!items&&info.parentElement!==scroll)scroll.append(info);
  let saving=bottom.querySelector('[data-buce-v2-fixed-saving]');
  if(!saving){saving=document.createElement('div');saving.dataset.buceV2FixedSaving='';saving.hidden=true;saving.setAttribute('aria-live','polite');saving.append(document.createElement('span'),document.createElement('strong'));button.before(saving);}
  const totalLabel=bottom.querySelector('.t4s-cart-total');if(totalLabel&&!totalLabel.querySelector('[data-buce-currency]')){const currency=document.createElement('small');currency.dataset.buceCurrency='';currency.textContent=document.querySelector('buce-v8-checkout-focus').dataset.currency;totalLabel.append(currency);}
  const keep='.t4s-cart-total,.t4s-cart__agree,button[name="checkout"],[data-buce-v2-fixed-saving],[data-buce-ah-mount]';
  const extrasToMove=[...bottom.children].filter(node=>!node.matches(keep));
  if(extrasToMove.length){
   let extras=scroll.querySelector('[data-buce-v2-extras]');
   if(!extras){extras=document.createElement('div');extras.dataset.buceV2Extras='';scroll.append(extras);}
   extrasToMove.forEach(node=>{
    const key=node.id||(node.hasAttribute('data-cart-discounts')?'cart-discounts':node.className);
    if(typeof key==='string'&&key){[...extras.children].filter(child=>child.dataset.buceExtraKey===key).forEach(child=>child.remove());node.dataset.buceExtraKey=key;}
    extras.append(node);
   });
  }
  const ah=root.querySelector('[data-buce-ah-mount]')?savingsMount(root):null;
  if(ah){const header=root.querySelector('.t4s-drawer__header');if(header&&header.nextElementSibling!==ah)header.after(ah);}if(button!==bottom.lastElementChild)bottom.append(button);
  root.querySelectorAll('div[data-cart-tool_action]').forEach(tool=>{tool.setAttribute('role','button');tool.setAttribute('tabindex','0');const label=tool.getAttribute('title')||tool.getAttribute('data-t4s-tooltip');if(label)tool.setAttribute('aria-label',label);});
 }
 function polish(){
  const labels=document.querySelector('buce-v10-commerce')?.dataset||{};
  const short=document.querySelector('buce-v8-checkout-focus')?.dataset||{};
  document.querySelectorAll('#t4s-mini_cart .t4s-order-discount__item,.t4s-cartPage__form .t4s-order-discount__item').forEach(row=>{
   if(row.hasAttribute('data-buce-cro-polished'))return;
   const raw=row.textContent.replace(/\s+/g,' ').trim();
   const title=raw.replace(/\s*\((-?[^)]+)\)\s*$/,'').trim();
   const amount=raw.match(/\((-?[^)]+)\)\s*$/)?.[1];
   const normalized=title.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
   let text='';
   if(normalized.includes('paga menos'))text=normalized.includes('august')?labels.labelAugust:labels.labelVolume;
   else if(normalized.includes('ahorro adicional por cantidad'))text=short.volumeShort;
   else if(normalized.includes('august')&&normalized.includes('50'))text=short.augustShort;
   else if(normalized.includes('compra 5')&&normalized.includes('6to'))text=labels.labelFree;
   else if(normalized.includes('nrw')&&normalized.includes('panoleta'))text=labels.labelNrw;
   if(row.closest('#t4s-mini_cart')&&text===labels.labelVolume)text=short.volumeShort;
   if(row.closest('#t4s-mini_cart')&&text===labels.labelFree)text=short.giftShort;
   row.dataset.buceCroPolished='true';
   if(!amount)return;if(!text)text=title;
   row.setAttribute('aria-label',raw);row.title=raw;
   const icon=row.querySelector('svg')?.cloneNode(true);row.replaceChildren();if(icon)row.append(icon);
   const label=document.createElement('span');label.className='buce-v11-discount-label';label.textContent=text;row.append(label);
   const value=document.createElement('strong');value.className='buce-v11-discount-amount';value.textContent=row.closest('#t4s-mini_cart')?amount.replace(/\s*COP\b/g,'').replace(/,/g,'.').trim():amount;row.append(value);
  });
 }
 function observe(){
  document.querySelectorAll('#t4s-mini_cart,.t4s-cartPage__form').forEach(element=>{
   const root=element.closest('[id^="shopify-section-"]')||element;
   if(observed.has(root))return;observed.add(root);
   new MutationObserver(records=>{
    const external=records.some(record=>{
     const target=record.target.nodeType===1?record.target:record.target.parentElement;
     if(target?.closest(own))return false;
     const nodes=[...record.addedNodes,...record.removedNodes];
     return nodes.length===0||nodes.some(node=>!(node.nodeType===1&&node.matches(own)));
    });
    if(external){clearTimeout(prepareTimer);prepareTimer=setTimeout(()=>{prepare();polish();request();},90);}
   }).observe(root,{childList:true,subtree:true,characterData:true});
  });
 }
 function render(status){
  prepare();
  document.querySelectorAll(selector).forEach(button=>{
   const root=button.closest('#t4s-mini_cart,.t4s-cartPage__form');if(!root)return;
   let mount=root.querySelector('[data-buce-v8-info]');
   if(!mount){mount=document.createElement('div');mount.dataset.buceV8Info='';(button.closest('.t4s-btn-group__checkout-update')||button).after(mount);}
   const signature=status.outerHTML,reuse=renderedStatus.get(mount)===signature;
   const focusedRail=document.activeElement?.matches('[data-buce-rail-track]')&&root.contains(document.activeElement)?document.activeElement.closest('[data-buce-cart-rail]')?.dataset.buceCartRail:null;
   const clone=status.cloneNode(true);clone.querySelectorAll('template').forEach(node=>node.remove());
   const progress=clone.querySelector('[data-buce-ah-progress]');
   clone.querySelector('[data-buce-ah-cart]')?.remove();
   const ah=savingsMount(root);
   const anchor=button.closest('.t4s-btn-group__checkout-update')||button;
   if(root.id==='t4s-mini_cart'){root.querySelector('.t4s-drawer__header')?.after(ah);}else if(root.firstElementChild!==ah)root.prepend(ah);
   if(progress)ah.replaceChildren(progress);else ah.replaceChildren();
   if(window.BuceAH)window.BuceAH.paint(ah);window.BucePolish?.paint(ah);
   const motivation=clone.querySelector('[data-buce-cart-motivation]');
   const stack=clone.querySelector('.buce-aov-stack');
   if(stack){const rails=[...stack.children].filter(node=>node.hasAttribute('data-buce-cart-rail'));if(rails.length){const group=document.createElement('section');group.className='buce-cart-complements';const heading=document.createElement('h3');heading.textContent=document.querySelector('buce-v8-checkout-focus').dataset.complementsLabel;group.append(heading);rails.sort((a,b)=>['accessories','shoes','shirts'].indexOf(a.dataset.buceCartRail)-['accessories','shoes','shirts'].indexOf(b.dataset.buceCartRail));rails.forEach(node=>group.append(node));stack.append(group);}}
   if(root.id==='t4s-mini_cart'){
    const motivationMount=root.querySelector('[data-buce-cart-motivation-mount]');
    if(motivationMount){motivationMount.replaceChildren();if(motivation){motivationMount.append(motivation.cloneNode(true));motivationMount.hidden=false;}else motivationMount.hidden=true;}
    motivation?.remove();
    clone.querySelector('.buce-v9-savings')?.remove();
    const saving=root.querySelector('[data-buce-v2-fixed-saving]');
    if(saving){saving.querySelector('span').textContent=status.dataset.buceSavingLabel;saving.querySelector('strong').textContent=status.dataset.buceSavingMoney;saving.hidden=Number(status.dataset.buceSaving)<=0||Number(status.dataset.buceItemCount)===0;saving.removeAttribute('aria-busy');}
   }
   if(!reuse){mount.replaceChildren(clone);renderedStatus.set(mount,signature);}mount.hidden=Number(status.dataset.buceItemCount)===0;if(focusedRail)mount.querySelector('[data-buce-cart-rail="'+focusedRail+'"] [data-buce-rail-track]')?.setAttribute('data-buce-rail-focus','');window.BuceCartRails?.mount(mount);
   mount.querySelectorAll('.buce-august-nudge select[data-buce-cart-variant]').forEach(select=>select.dispatchEvent(new Event('change',{bubbles:true})));
  });
  if(Number(status.dataset.buceItemCount)===0){document.querySelectorAll('.t4s-main_cart__empty,#t4s-mini_cart [data-buce-empty-finder]').forEach(empty=>{
   const root=empty.closest('#t4s-mini_cart')||empty;
   const ah=savingsMount(root);
   if(!ah.isConnected)empty.append(ah);
   const progress=status.querySelector('[data-buce-ah-progress]');if(progress)ah.replaceChildren(progress.cloneNode(true));
  });}
  document.querySelectorAll('[data-buce-ah-progress]').forEach(node=>{if(window.BuceAH)window.BuceAH.paint(node);window.BucePolish?.paint(node);});
  polish();observe();
 }
 document.addEventListener('buce:cart-status',event=>{if(event.detail?.state)render(event.detail.state);});
 document.addEventListener('buce:cart-loading',()=>{document.querySelectorAll('[data-buce-v2-fixed-saving]').forEach(node=>node.setAttribute('aria-busy','true'));});
 document.addEventListener('buce:cart-error',()=>{document.querySelectorAll('[data-buce-v2-fixed-saving],[data-buce-v8-info]').forEach(node=>{node.hidden=true;});});
 document.addEventListener('keydown',event=>{const tool=event.target.closest?.('#t4s-mini_cart div[data-cart-tool_action]');if(tool&&(event.key==='Enter'||event.key===' ')){event.preventDefault();tool.click();}});
 document.addEventListener('change',event=>{
  const offerSelect=event.target.closest?.('select[data-buce-cart-variant][data-offer-savings-label]');
  if(offerSelect){
   const card=offerSelect.closest('.buce-socks-nudge'),option=offerSelect.selectedOptions[0];
   const add=offerSelect.closest('[data-buce-cart-quickadd]')?.querySelector('[data-buce-cart-add]');if(add)add.disabled=!offerSelect.value;
   if(!card||!option||!offerSelect.value)return;
   const amount=Number(option.dataset.offerPrice),reference=Number(option.dataset.offerCompare);
   const row=card.querySelector('.buce-cart-offer-price'),price=card.querySelector('[data-buce-cart-current]');
   if(price)price.textContent=option.dataset.offerMoney;
   if(row){
    row.hidden=!(reference>amount);
    row.querySelector('[data-buce-offer-compare]').textContent=option.dataset.offerCompareMoney;
    row.querySelector('[data-buce-offer-savings]').textContent=offerSelect.dataset.offerSavingsLabel.replace('__AMOUNT__',option.dataset.offerSavingsMoney);
    const percent=row.querySelector('[data-buce-offer-percent]');
    percent.hidden=offerSelect.hasAttribute('data-offer-hide-percent')||!(reference>amount);
    percent.textContent='−'+(reference>0?Math.round((reference-amount)*100/reference):0)+'%';
   }
   const image=card.querySelector(':scope>img');
   if(image&&option.dataset.offerImage){image.src=option.dataset.offerImage;image.removeAttribute('srcset');image.alt=option.dataset.offerTitle;}
   const title=card.querySelector('[data-buce-cart-title]');if(title&&option.dataset.offerTitle)title.textContent=option.dataset.offerTitle;if(title?.tagName==='A'){const url=new URL(title.href,location.origin);url.searchParams.set('variant',offerSelect.value);title.href=url.pathname+url.search;}
   return;
  }
  const select=event.target.closest?.('.buce-quick-buy select[name="id"]');if(!select||!select.value)return;
  const card=select.closest('[data-buce-complement]'),option=select.selectedOptions[0];if(!card||!option?.dataset.price)return;
  const price=card.querySelector('[data-buce-variant-price]'),comparison=card.querySelector('[data-buce-variant-compare]');
  if(price)price.textContent=option.dataset.price;
  if(comparison){comparison.textContent=option.dataset.compare||'';comparison.hidden=!option.dataset.compare;}
 });
 async function refreshNativeMiniCart(){
  const root=window.Shopify?.routes?.root||'/';
  const sectionUrl=new URL(root,location.origin);sectionUrl.searchParams.set('section_id','mini_cart');
  const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview)sectionUrl.searchParams.set('preview_theme_id',preview);
  const [sectionResponse,cartResponse]=await Promise.all([
   fetch(sectionUrl,{credentials:'same-origin',cache:'no-store'}),
   fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}})
  ]);
  if(sectionResponse.ok){
   const doc=new DOMParser().parseFromString(await sectionResponse.text(),'text/html');
   const freshItems=doc.querySelector('[data-cart-items]'),currentItems=document.querySelector('#t4s-mini_cart [data-cart-items]');
   // Keep the native cart-items root: Gecko delegates quantity/remove events to it.
   if(freshItems&&currentItems)currentItems.replaceChildren(...freshItems.childNodes);
   const freshBottom=doc.querySelector('.t4s-drawer__bottom'),currentBottom=document.querySelector('#t4s-mini_cart .t4s-drawer__bottom');
   if(freshBottom&&currentBottom)currentBottom.replaceWith(freshBottom);
  }
  if(cartResponse.ok){
   const cart=await cartResponse.json();
   document.querySelectorAll('[data-cart-count]').forEach(node=>{node.textContent=cart.item_count;node.classList.toggle('t4s-op-0',cart.item_count===0);});
  }
  prepare();polish();request();
 }
 document.addEventListener('click',async event=>{
  const button=event.target.closest?.('button[data-buce-cart-add]');if(!button)return;
  const control=button.closest('[data-buce-cart-quickadd]'),select=control?.querySelector('select[data-buce-cart-variant]');
  if(!control||!select?.value||button.disabled)return;
  event.preventDefault();event.stopImmediatePropagation();
  const original=button.textContent,originalLabel=button.getAttribute('aria-label')||original;button.dataset.buceAddState='loading';button.disabled=true;button.textContent='Agregando…';
  try{
   const root=window.Shopify?.routes?.root||'/';
   const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({items:[{id:select.value,quantity:1}]})});
   if(!response.ok)throw new Error('No se pudo agregar');
   button.textContent='¡Agregado!';button.dataset.buceAddState='added';
   document.dispatchEvent(new CustomEvent('buce:cart-refresh'));
   if(button.closest('.t4s-cartPage__form')){location.reload();return;}
   try{await refreshNativeMiniCart();}catch(refreshError){document.dispatchEvent(new CustomEvent('buce:cart-refresh'));}

   document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
   window.BuceCartUI?.refresh();
  }catch(error){button.textContent='Intenta otra vez';button.dataset.buceAddState='error';button.setAttribute('aria-label','Intenta otra vez');console.warn('[Buce cart quick add]',error.message);}
  finally{setTimeout(()=>{button.disabled=false;button.textContent=original;delete button.dataset.buceAddState;button.setAttribute('aria-label',originalLabel);},1200);}
 },true);
 function start(){prepare();polish();observe();if(window.BuceCartUI)window.BuceCartUI.replay();else request();}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('shopify:section:load',start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.BuceV2PaymentGuard) return;

  const sync = (select) => {
    if (!(select instanceof HTMLSelectElement) || select.name !== 'id') return;
    const callback = select.closest('[data-callBackVariant]');
    const payment = callback?.querySelector('[data-buce-dynamic-payment]');
    if (!(payment instanceof HTMLElement)) return;
    payment.hidden = !select.value;
  };

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (target instanceof HTMLSelectElement && target.matches('.t4s-product__select[name="id"]')) sync(target);
  });

  window.BuceV2PaymentGuard = { sync };
})();
  } catch(e) { console.error(e); }
})();

})();
